import { render, staticRenderFns } from "./alarmDetail.vue?vue&type=template&id=8045a64c&scoped=true"
import script from "./alarmDetail.vue?vue&type=script&lang=js"
export * from "./alarmDetail.vue?vue&type=script&lang=js"
import style0 from "./alarmDetail.vue?vue&type=style&index=0&id=8045a64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8045a64c",
  null
  
)

export default component.exports